import { computed } from "#imports";
const getBackgroundColor = computed(() => {
  return (el) => {
    while (el) {
      if (el.tagName === "DIV" && el.id.includes("voix-slice")) {
        if (getComputedStyle(el).backgroundColor) {
          return getComputedStyle(el).backgroundColor;
        }
      }
      if (el.parentElement) {
        el = el.parentElement;
      } else {
        break;
      }
    }
    return "";
  };
});
const vVoixBackgroundColor = {
  async updated(el) {
    setTimeout(() => {
      const backgroundColor = getBackgroundColor.value(el);
      if (backgroundColor && backgroundColor !== "rgba(0, 0, 0, 0)") {
        el.style.backgroundColor = backgroundColor;
      }
    }, 50);
  },
  mounted(el) {
    const backgroundColor = getBackgroundColor.value(el);
    if (backgroundColor && backgroundColor !== "rgba(0, 0, 0, 0)") {
      el.style.backgroundColor = backgroundColor;
    }
  }
};
export default vVoixBackgroundColor;
